var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.slotComponents.length)?_c('div',{staticClass:"plugin-slot"},_vm._l((_vm.slotComponents),function(component,index){return _c(component,_vm._b({key:`${_vm.name}-${index}`,tag:"component"},'component',_vm.slotProps,false))}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }